/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/908/interface/api/cat_8997
 */

import { message } from 'ant-design-vue'
import {
  i18n_key_addOrUpdate_post,
  i18n_key_list_post,
  i18n_value_list_post,
  i18n_value_update_post,
  i18n_upload_post,
  site_all
} from 'server/modules/8997'

// 新增Or更新多语言KEY
export const i18n_key_addOrUpdate_post_ = async function(params) {
  const { success, data, retInfo } = await i18n_key_addOrUpdate_post(params)
  if (success) {
    message.success(retInfo)
    return Promise.resolve(data)
  } else {
    message.error(retInfo)
    return Promise.resolve(data)
  }
}

// 多语言KEY列表
export const i18n_key_list_post_ = async function(params) {
  const { success, data, retInfo } = await i18n_key_list_post(params)
  if (success) {
    return Promise.resolve(data)
  } else {
    message.error(retInfo)
    return Promise.resolve(data)
  }
}

// 多语言文案列表
export const i18n_value_list_post_ = async function(params, query) {
  const { success, data, retInfo } = await i18n_value_list_post(params, query)
  if (success) {
    return Promise.resolve(data)
  } else {
    message.error(retInfo)
    return Promise.reject(data)
  }
}

// 多语言文案更新
export const i18n_value_update_post_ = async function(params) {
  const { success, data, retInfo } = await i18n_value_update_post(params)
  if (success) {
    message.success(retInfo)
    return Promise.resolve(data)
  } else {
    message.error(retInfo)
    return Promise.reject(data)
  }
}

// 文件上传
export const i18n_upload_post_ = async function(params) {
  const { success, data, retInfo } = await i18n_upload_post(params)
  if (success) {
    message.success(retInfo)
    return Promise.resolve(data)
  } else {
    message.error(retInfo)
    return Promise.resolve(data)
  }
}

// 获取站点
export const site_all_ = async function(params) {
  const { success, data, retInfo } = await site_all(params)
  if (success) {
    return Promise.resolve(data)
  } else {
    message.error(retInfo)
    return Promise.reject(data)
  }
}
